// Per-page SEO config: title + meta description for each route.
export const SEO = {
  "/": {
    title: "Daisy Does | Practical Help, Calmly Done",
    description:
      "Friendly practical support with admin, forms, benefit applications, household paperwork and everyday tasks. Daisy Does helps elderly clients, families and busy households feel on top of things and back in control.",
  },
  "/services": {
    title: "Admin & Everyday Support Services | Daisy Does",
    description:
      "Benefit application support, household admin, elderly support, family support and form-filling help. Practical admin services from Sarah at Daisy Does.",
  },
  "/benefit-application-help": {
    title: "Benefit Application Help | Attendance Allowance, Pension Credit & Blue Badge Support — Daisy Does",
    description:
      "Friendly help with benefit applications including Attendance Allowance, Pension Credit, Blue Badge and Council Tax Reduction. Daisy Does helps gather the information, complete forms and explain next steps.",
  },
  "/elderly-support": {
    title: "Support for Elderly People with Forms & Admin | Daisy Does",
    description:
      "Patient, respectful help for older people who find forms, websites, letters and official applications stressful or confusing. Calm support for families too.",
  },
  "/about": {
    title: "About Sarah | Daisy Does",
    description:
      "Meet Sarah — the friendly, methodical person behind Daisy Does. Calm, kind, capable help with the admin side of life.",
  },
  "/pricing": {
    title: "Pricing | Daisy Does",
    description:
      "Simple, clear pricing. Free 15-minute introductory call, £45 per hour for admin support, fixed fees for benefit applications and home admin sessions.",
  },
  "/contact": {
    title: "Contact Daisy Does | Book a Free Introductory Call",
    description:
      "Book a free 15-minute introductory call with Sarah, send a message or call 07771 361 508. Friendly, practical admin support from Daisy Does.",
  },
  "/privacy": {
    title: "Privacy Policy | Daisy Does",
    description: "How Daisy Does collects, uses and protects your personal data. Read our plain-English privacy policy.",
  },
  "/terms": {
    title: "Terms of Service | Daisy Does",
    description: "The terms that apply when you use Daisy Does services. Simple, plain-English terms of service.",
  },
  "/cookies": {
    title: "Cookie Policy | Daisy Does",
    description: "How Daisy Does uses cookies on this website. Simple, plain-English cookie policy.",
  },
};

export default SEO;
